import React, { useState } from 'react';
import styled from '@emotion/styled';

import ApplicationStatistics from './ApplicationStatistics/ApplicationStatistics';
import Banner from './Banner/Banner';
import LocumContacts from './LocumContact/LocumContact';
import ViewAllPostedJobs from './ViewAllPostedJobs/ViewAllPostedJobs';
import YourPostedJobs from './YourPostedJobs/YourPostedJobs';
import HomeSide from './HomeSide/HomeSide';
import { MenuUnfoldRight } from '../../../components/Icons/MenuUnfoldRight';
import { MenuFoldLeft } from '../../../components/Icons/MenuUnfoldLeft';

const HealthDashboardHome = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleHomeSide = () => setIsExpanded((prev) => !prev);

  return (
    <Shell>
      <Container expanded={isExpanded}>
        <ToggleButton onClick={toggleHomeSide}>
          {isExpanded ? <MenuUnfoldRight /> : <MenuFoldLeft />}
        </ToggleButton>
        <Banner />
        <ApplicationStatistics />
        <ContentGrid expanded={isExpanded}>
          <YourPostedJobs />
          <LocumContacts />
        </ContentGrid>
        <ViewAllPostedJobs />
      </Container>
      <HomeSide isExpanded={isExpanded} toggleFromParent={toggleHomeSide} />
    </Shell>
  );
};

export default HealthDashboardHome;

const Shell = styled.div`
  display: flex;
  justify-content: space-between;
  overflow-x: hidden;
  width: 100%;
  position: relative;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

interface ContainerProps {
  expanded: boolean;
}

const Container = styled.section<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
  padding-top: 3rem;
  width: ${({ expanded }) => (expanded ? '68%' : '100%')};
  transition: width 0.4s ease-in-out;
  position: relative;

  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (max-width: 480px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const ContentGrid = styled.div<ContainerProps>`
  transition: all 0.4s ease-in-out;
  display: grid;
  grid-template-columns: ${({ expanded }) => (expanded ? '1fr' : '1fr 1fr')};
  gap: 1.75rem;

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
  }
`;

const ToggleButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.mainBlue};
  background: white;
  padding: 0.3rem;
  border-radius: 10px;

  @media (max-width: 1024px) {
    position: relative;
    width: fit-content;
    display: none;
  }
`;
